import "./Solution.module.css";
import Navigation from "@/reusable_sections/Header";
import HeroInvisibleClimate from "./sections/HeroInvisibleClimate";
import InvisibleClimate from "./sections/InvisibleClimate";
import Installation from "./sections/Installation";
import TechnicalFaq from "./sections/TechnicalFaq";
import Footer from "@/reusable_sections/Footer";
export default function SolutionPage() {
  return <div>
      <Navigation />
      
      <InvisibleClimate />
      <Installation />
      <TechnicalFaq />
      <Footer />
    </div>;
}